import { DISMISS_TOAST, SHOW_TOAST } from 'states/constants';

export const showToast = dispatch => (message, options) => {
  dispatch({ type: SHOW_TOAST, payload: { message, show: true, ...options } });
};

export const dismissToast = dispatch => dispatch({ type: DISMISS_TOAST });
